<section class="landing">
  <img src="assets/FTD_Banner.webp" alt="ftdbanner" loading="eager" width="1350" height="560" class="banner-img img-fluid" >
</section>
<app-sub-header></app-sub-header>
<section class="section section-job-match open-position py-5" id="intell-match" *ngIf="fieldValue==null">
	<div *ngIf="check" class="container">
    <div class="row">
      <div class="col-md-12 text-center">
       <h1 class="text-center">
        Intelligent Career Match
       </h1>
      </div>
    </div>
	  <lib-find-your-spot [descriptionText]="''" themeName="zm-custom-theme" (recommendedJobsFetchEvent)="onRecommendeJobsFetch($event)"></lib-find-your-spot>
	</div>
</section>
<section class="job-section find-ur-div" id="myDiv" *ngIf="showRecommendedJobs">
  <div>
    <div class="container">
      <div class="row">
        <h3 class="reset-text text-center" *ngIf="jobsData.length > 0" >Matching opportunities recommended for you</h3>
      </div>
          <div class="row">
            <div class="col-md-6 mb-50 col-lg-4"*ngFor="let attr of jobsData">
              <div class="opening-block">
                <h3><a href="javascript:void(0)"  (click)="setJobURL(attr.jobUrl)">{{attr.jobTitle}}</a></h3>
      <p class="job-exp no-wrp"> Experience: <b>{{attr.minYrsOfExperience}} - {{attr.maxYrsOfExperience}} Years </b></p>
      <p class="job-location no-wrp">Location: <b> {{attr.location}}</b></p>
                <div class="apply-row">
                  <!-- <a href="javascript:void(0)" (click)="setJobURL(attr.jobUrl)" class="btn-apply block-a"> Apply </a> -->
                </div>
              </div>
            </div>
              </div>
    </div>
       <div *ngIf="jobsData.length == 0 && showRecommendedJobs" id="msg">
  <div class="container">
    <div class="row ng-scope">
      <h3 class="reset-text">
  Sorry, there are no matching opportunities found. 
</h3>
       <div class="col-md-12 text-center mt-20">
       </div>
     </div>
             </div>
            
 </div>
  </div>  
  <div class="row w-100 justify-content-center mt-5">
    <div class="col-md-12 text-center">
        <button  class="reset-div mt-20" (click)="hideDivById()">Reset</button>
    </div>
</div>   
</section>
<section id="about-us" class="background-white section2">
  <div class="container">              
      <div class="row align-items-center justify-content-center">
          <div class="col-md-12">
              <div class="overflow-padding less-overflow-padding ">
                  <h2 class="fs-3 fs-sm-4" style=" text-align: center;">
                  <span class="underline">about us</span>
                    </h2>
                  <p class="para-text ">FTD has been a leader in the floral industry for over a century. We are a private equity-backed company with one of the largest florist networks in the world, supported by the iconic Mercury Man© logo displayed in over 30,000 floral shops in more than 125 countries. We partner with local florists to hand-craft floral arrangements available for same-day delivery on FTD.com and ProFlowers.com. In addition to delivering flowers, we support locally-owned retail florists by providing technology, marketing, and digital services to members of our florist network. For all of life’s occasions and everyday moments, visit FTD.com, ProFlowers.com and ProPlants.com, and follow us on Facebook and Instagram at @ftdflowers. We love helping our customers #sayitwithflowers.</p>

                  <p class="para-text ">FTD India Private Limited, an offshore delivery center of FTD LLC. is an e-commerce technology company focused on providing product development and services support on multiple processes, domains and technologies. Located at My Home Hub, Madhapur, Hyderabad, it is the largest off-shore destination for FTD LLC. and provides complete range of software development, technical support and remote infrastructure management services. Our product teams work on technologies which include Web Technologies, Client Server Technologies and Enterprise Technologies with a unified goal of serving our customers and giving them a best shopping experience possible.</p>
              </div>
          </div> 
      </div> 
  </div> 
</section>
<section id="value" class="valuescroll ng-scope">
  <div class="container">
      <div class="row">
          <div class="value_heading">
              <img src="assets/FTD_Logowhite.svg" alt="FTD_Logowhite" class="img-fluid" height="166" width="351" loading="lazy">
              <h2 class="fnt-sze-36">Our Values</h2>
          </div>
          <div class="col-md-3">
              <div class="value_cont">
                  <h1>Be a Customer-Focused Leader</h1>
                  <span>-</span>
                  <p>Make serving all customers your
                      #1 priority. Remember that your
                      customers can be both internal
                      (colleagues) and external
                      (consumers, partners, clients and
                      members).
                  </p>
                  <p>Be holistic. You are part of a bigger
                     team and not working in a vacuum,
                     so consider the needs and
                     perspectives of others.
                  </p>
                  <p>Be professional and solution
                     oriented. Share knowledge,
                     remove obstacles, and help others
                     succeed.
                  </p>
              </div>
          </div>
          <div class="col-md-3">
              <div class="value_cont">
                  <h1>Be an Entrepreneur</h1>
                  <span>-</span>
                  <p>Be innovative and be resilient
                      when you fail (and failure will
                      happen).
                  </p>
                  <p>Be accountable. Own your
                      mistakes.
                  </p>
                  <p>Be data driven. Back up your
                      decisions with facts, not opinions.
                      Use rigor in making business
                      cases.
                  </p>
              </div>
          </div>
          <div class="col-md-3">
              <div class="value_cont">
                  <h1>Be a Good Person</h1>
                  <span>-</span>
                  <p>Be positive and respectful. Don’t
                      be a jerk. Set good examples and
                      act with integrity in all you do.
                      Embody the power and joy of
                      giving.
                  </p>
                  <p>Be fair and equitable in your
                      decisions. Promote diversity,
                      inclusion and belonging at every
                      level.
                  </p>
                  <p>Be honest in your communications
                      and assume positive intent in the
                      communications of others.
                  </p>
              </div>
          </div>
          <div class="col-md-3">
              <div class="value_cont">
                  <h1>Be Engaged</h1>
                  <span>-</span>
                  <p>Be proactive. Run with your plans,
                      objectives and goals. Seek, drive,
                      and reward outcomes beyond
                      what is good enough. Celebrate
                      successes.
                  </p>
                  <p>Be an active listener.</p>
                  <p>Speak up and be a champion for
                      asking the hard questions and
                      giving the hard answers, even
                      when doing so is unpopular.
                  </p>
              </div>
          </div>
      </div>  
  </div>   
</section>
<section class="mtb-30 mt-80 joblist-sec pd-btm-50" id="current_openings">
  <div class="container">
    <div class="row">
      <div class="cntr-div">
        <div class="">
          <h2 class="abt-cntr">Current Opportunities</h2>
        </div>
      </div>
    </div>
  </div>
  <!-- <lib-find-your-spot></lib-find-your-spot> -->
  <div class="container text-center" *ngIf="!!fieldValue;else allJobsDisplayTemplateRef">
    <div class="row">
      <lib-jobs-list-es (jobURL)="setJobURL($event)" [fieldValue]="fieldValue" class="deparment-list"></lib-jobs-list-es>
    </div>
  </div>
  <ng-template #allJobsDisplayTemplateRef>
    <div class="container kohler-joblist-space">
      <div class="row">
        <!--<div class="col-md-3 mt-2"><lib-facets class="width-auto facet-lib"></lib-facets></div>-->
        <div *ngIf="!isMobileView" class="col-lg-3">
          <lib-facets [isPopupRequired]=true [isHorizontal]=false themeName="zm-custom-theme" class="d-none d-lg-block"></lib-facets>
        </div>
        <div class="col-md-9">
          <div class="col-12">
            <lib-zm-search appearance="outline" label="Search" placeholder="Enter keywords to search" [showSearchIconInside]="true" (allJobsCount)="setJobsCount($event)" (onSearchEvent)="refreshJobsOnSearch($event)"></lib-zm-search>
            <span class="filter-btn">
              <button class="m-3" *ngIf="isMobileView" (click)="openPopup()">Filters</button>
            </span>
            <lib-filter-chips class="d-none-mob"></lib-filter-chips>
          </div>
          <div class="col-12 mb-4">
            <div class="count-banner" *ngIf="allJobsCount >= 0">
              {{allJobsCount}} openings found
            </div>
            <lib-jobs-list (emitApplyData)="setTalentApplyResult($event)" [showMoreBtn]="true" [chipsViewForSkills]="true" (jobURL)="setJobURL($event)" class="job-list-sec"></lib-jobs-list>
          </div>
          <div class="col-12">
            <div class="row">
              <div class="col-md-4"></div>
              <div class="col-md-8 d-flex justify-content-end">
                <lib-pagination></lib-pagination>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-template>
</section>
<ng-template #filtersPopup>
  <div class="d-flex justify-content-between mb-3 mt-2 mx-1">
    <div>Filters</div>
    <button class="btn-popup-close" (click)="closePopup()"><img src="assets/close-sm.svg" alt="close" height="24" width="24"></button>
  </div>
  <lib-filter-chips></lib-filter-chips>
  <lib-facets [isPopupRequired]=true [isUsedInPopup]=true [isHorizontal]=false [isClearAll]="clearAll" themeName="zm-custom-theme"></lib-facets>
  <div class="d-lg-none d-flex justify-content-end footer">
    <button class="clear-sec" (click)="clearSideFilter()">CLEAR ALL</button>
    <button mat-stroked-button class="ms-3 me-2 close-sec" (click)="closePopup()">SHOW JOBS</button>  </div>
</ng-template>
<section class="section4 ng-scope" id="life-at-ftd-india">
  <div class="container">
      <div class="row">
          <div class="col-12 mb-2 mb-md-7 text-center">
                <h2 class="fs-3 fs-sm-4">
                    <span class="underline">Life @ FTD India</span>  
                </h2>
                <p class="para-text">The FTD team brings together driven individuals in a way that capitalizes on their natural talents. Every job counts, and so does every employee. This helps us cultivate an engaging, enjoyable atmosphere where each person can excel - and the collective group is always moving forward. We're innovators. We're creative. We're savvy. And yes, we're people who like to have fun...especially on the job.</p>
                <p class="para-text">Our proprietary technology has led to rapid growth and profitability, strengthening each brand and fostering a positive work environment that continues to attract movers and shakers. And because we're "people" people, it has earned us a glowing reputation for providing an exceptional customer experience with every order.</p>
                <p class="para-text">More importantly, we have evolved into a premier place to work because we have a casual yet fast-moving environment. Our proactive, progressive company is results driven. This has created an exciting atmosphere with plenty of good energy to go around.</p>
                <p class="para-text">FTD’s India facility is conveniently located in the IT Hub of Hyderabad – Hi-Tech City . We operate from My Home Hub, B-Block, 6th Floor. Our HQ is at Downtown Chicago, United States of America.</p>
          </div>
      </div>
      <div class="life_imgs row">
        <div class="col-md-4">
          <img src="assets/life/DG.webp" height="576" width="768" class="img-fluid" loading="lazy" alt="life @ FTD">
        </div>
        <div class="col-md-4">
          <img src="assets/life/Dg_1.webp" height="576" width="768" class="img-fluid" loading="lazy" alt="life @ FTD">
        </div>
        <div class="col-md-4">
          <img src="assets/life/DG3.webp" height="576" width="768" class="img-fluid" loading="lazy" alt="life @ FTD">
        </div>
    </div>
  </div> 
</section>